/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, August 5th 2022, 1:59:59 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { schemaBuilder } from "lib/validation";
import { JsonSchema, JSON_SCHEMA_DATA_TYPES } from "./jsonSchemaInterface";

export const JsonSchemaValidationSchema: schemaBuilder.SchemaOf<Pick<JsonSchema, "type">> = schemaBuilder
  .object()
  .shape({
    type: schemaBuilder.mixed().oneOf(Object.keys(JSON_SCHEMA_DATA_TYPES)).required("data type is required"),
  });
